import type { InventarisationSelectOption } from "@/models/inventarisation/InventarisationSelectOption";

/**
 * Sorts select options based off their label.
 * Ignores case, but not diatrical marks.
 */
export function sortOptions<T extends string>(
	options: InventarisationSelectOption<T>[],
): InventarisationSelectOption<T>[] {
	return [...options].sort((a, b) =>
		a.label.localeCompare(b.label, undefined, { sensitivity: "accent" }),
	);
}
